export const ADD_SINDROME = "ADD_SINDROME";
